module.exports = __webpack_public_path__ + "static/media/exchangeGames-lines2.87cbb252.svg";